import { Market } from "./domain/models/Market";
import { environment } from "./environments/environment";

export const marketsArrayDE: Market[] = [
    JSON.parse(environment.MARKET_1_DE),
    JSON.parse(environment.MARKET_2_DE),
    JSON.parse(environment.MARKET_3_DE),
    JSON.parse(environment.MARKET_4_DE),
    JSON.parse(environment.MARKET_5_DE),
];

export const marketsArrayFR: Market[] = [
    JSON.parse(environment.MARKET_1_FR),
    JSON.parse(environment.MARKET_2_FR),
    JSON.parse(environment.MARKET_3_FR),
    JSON.parse(environment.MARKET_4_FR),
    JSON.parse(environment.MARKET_5_FR),
];

export const email = environment.EMAIL;
export const phone = environment.PHONE;
export const website = environment.WEBSITE;

export const instagramLink1 = environment.INSTAGRAM_1;
export const instagramLink2 = environment.INSTAGRAM_2;

export const currentYear = environment.CURRENT_YEAR;
